package cz.lhoracek.mapl

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.apps
import dev.gitlive.firebase.initialize
import kotlinx.browser.document
import kotlinx.browser.window
import kotlin.js.unsafeCast

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    initializeFirebaseForWeb()
    ComposeViewport(document.body ?: error("Missing <body> for Compose viewport")) {
        App()
    }
}

private fun initializeFirebaseForWeb() {
    val firebaseConfig = window.asDynamic().__MAPL_FIREBASE_CONFIG__.unsafeCast<WebFirebaseConfig?>() ?: return
    val appId = firebaseConfig.appId ?: return
    val apiKey = firebaseConfig.apiKey ?: return

    if (Firebase.apps(Unit).isNotEmpty()) return

    Firebase.initialize(
        context = Unit,
        options = FirebaseOptions(
            applicationId = appId,
            apiKey = apiKey,
            databaseUrl = firebaseConfig.databaseURL,
            storageBucket = firebaseConfig.storageBucket,
            projectId = firebaseConfig.projectId,
            gcmSenderId = firebaseConfig.messagingSenderId,
            authDomain = firebaseConfig.authDomain,
        ),
    )
}

private external interface WebFirebaseConfig {
    val apiKey: String?
    val appId: String?
    val authDomain: String?
    val projectId: String?
    val storageBucket: String?
    val messagingSenderId: String?
    val databaseURL: String?
}
